import type { ReactNode } from 'react';
import { useAuth } from 'react-oidc-context';

type LoginRouteProps = {
  login: ReactNode;
  redirect: ReactNode;
};

/**
 * An already authenticated user opening /login is sent on to the default page of the instance the
 * session resolved to, instead of being shown the login form (which would also wipe their session data).
 */
export const LoginRoute = ({ login, redirect }: LoginRouteProps): ReactNode => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? redirect : login;
};
